import { SearchInput } from '@billy/design-system'
import React, { ChangeEvent, ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useSegment } from '../../../../../../hooks'
import { useBankMatchesToolbarFilters } from '../../context/BankMatchesToolbarFiltersContext'

export const BankMatchesSearch = (): ReactElement => {
  const { queryParams, setQueryParams } = useBankMatchesToolbarFilters()
  const { t } = useTranslation()
  const { track } = useSegment()

  const isSearchInputFocused = !!queryParams.searchQuery

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setQueryParams({ searchQuery: event.target.value })
      track('XXX - Reconciliation Entries Searched (Client)')
    },
    [setQueryParams, track],
  )

  const handleClear = useCallback(() => {
    setQueryParams({ searchQuery: undefined })
  }, [setQueryParams])

  return (
    <SearchInput
      placeholder={t('bank_integration.toolbar.search')}
      focused={isSearchInputFocused}
      onChangeDebounced={handleChange}
      onClear={handleClear}
      value={queryParams.searchQuery}
    />
  )
}
